const GlobalControl = {

    // FIELDS
    "premise": "Premise",
    "invoicingName": "Invoicing Name (Seller Name)",
    "invoiceLogo": "Invoice Logo",
    "invoicePrefix": "Invoice Prefix",
    "gst": "GST",
    "pincode": "Pincode",
    "address": "Address",
    "due_date": "Due Date",
    "taxes": "Taxes",
    "label": "Label",
    "value": "Value",
    "terms_and_conditions": "Terms and Conditions",
    "two_way_auth": "Two Way Authentication",
    "defaulters_list": "Defaulters List",
    "smtpHost": "SMTP Host",
    "smtpPort": "SMTP Port",
    "smtpUser": "SMTP User",
    "smtpPassword": "SMTP Password",
    "smtpSecure": "SMTP Secure",
    "smtpEncryption": "SMTP Encryption",
    "mailDriver": "Mail Driver",
    "mailFromEmail": "Mail From Email",
    "mailFromName": "Mail From Name",
    "providerName": "Provider Name",
    "apiUrl": "API URL",
    "apiKey": "API Key",
    "apiSecret": "API Secret",
    "senderId": "Sender ID",
    "senderName": "Sender Name",
    "paymentGateway": "Payment Gateway",
    "parameter": "Parameter",
    "basic_configuration": "Basic Configuration",
    "gateway_parameters": "Gateway Parameters",

    // PAGE HEADER
    "global_control": "Global Control",

    // TABS
    "tab_accounts": "Accounts & Invoices",
    "tab_mfa": "Premise Setting",
    "tab_email_configuration": "Email Configuration",
    "tab_sms_configuration": "SMS Configuration",
    "tab_payment_gateway_config": "Payment Gateway Config",

    // ERROR
    "error_premise": "Select Premise",
    "error_invoicingName": "Enter Invoicing Name",
    "error_invoiceLogo": "Select Invoice Logo",
    "error_invoicePrefix": "Enter Invoice Prefix",
    "error_gst": "Enter GST",
    "error_pincode": "Enter Pincode",
    "error_invalid_pincode": "Enter Valid Pincode",
    "error_address": "Enter Address",
    "error_label": "Enter Label",
    "error_value": "Enter Value",
    "error_negative": "Cannot be negative",
    "error_smtpHost": "Enter SMTP Host",
    "error_smtpPort": "Enter SMTP Port",
    "error_smtpUser": "Enter SMTP User",
    "error_smtpPassword": "Enter SMTP Password",
    "error_smtpEncryption": "Select SMTP Encryption",
    "error_mailDriver": "Enter Mail Driver",
    "error_mailFromEmail": "Enter Mail From Email",
    "error_mailFromName": "Enter Mail From Name",
    "error_invalid_mailFromEmail": "Enter Valid Mail From Email",
    "error_providerName": "Enter Provider Name",
    "error_apiUrl": "Enter API URL",
    "error_apiKey": "Enter API Key",
    "error_apiSecret": "Enter API Secret",
    "error_senderId": "Enter Sender ID",
    "error_senderName": "Enter Sender Name",
    "error_paymentGateway": "Select Payment Gateway",
    "error_parameterValue": "Enter Value",

}

export default GlobalControl;